import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";

import { getGlobals } from "../../../Configs";
import { useSelector } from "react-redux";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  fKeyTabInput,
} from "../../../Utility/Utilitys";
import { confirmAlert } from "react-confirm-alert";
import moment from "moment";
import DetailComponent from "./DetailComponent";
import CloseIcon from "@mui/icons-material/Close";
import {
  CmpCheckboxField,
  CmpCheckboxFieldIndeterminate,
} from "../../../Component/Common/ToolBox/ToolBox";
import { CmpCheckboxFieldV1 } from "../../../Component/Common/ToolBox/ToolBoxV1";

const CycleCountCountingDetailModal = ({
  open,
  closeModal = () => {},
  vMediaQuery,
  rowData = {},
}) => {
  const [countingDetail, setCountingDetail] = useState([]);
  const [detailObj, setDetailObj] = useState({
    Barcode: "",
    pending: false,
  });

  const vRdxuserInfo = useSelector((state) => state.login.value);
  const baseURL = getGlobals().API_BASE_URL;
  useEffect(() => {
    if (open) {
      getRowApi(detailObj.Barcode, detailObj.pending);
    }

    setTimeout(() => {
      document.getElementsByName("barcode")[0]?.focus();
    }, 500);
  }, [open]);

  const getRowApi = async (barcode, pending) => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      let vobj = {
        SheetId: rowData.A_SheetId,
        Barcode: barcode,
        Pendingqty: pending,
      };
      const response = await axios.post(
        `${baseURL}cyclicCount/cyclicCountItemGetRow`,
        fcheck_null_undefine_replace_empty(vobj)
      );

      // Assuming response data structure is an array of objects
      if (response?.status === 200) {
        let GridID = response?.data?.recordset?.map((obj, i) => ({
          ...obj,
          id: i + 1,
        }));
        setCountingDetail(GridID);
        loader.style.display = "none";
      }
    } catch (error) {
      loader.style.display = "none";
      console.error("Error fetching cycle count data:", error);
    }
  };

  const postApi = async () => {
    let loader = document?.getElementById("loader");
    loader.style.display = "flex";
    try {
      const response = await axios.post(
        `${baseURL}cyclicCount/CycPhyVarianceCountPost`,
        fcheck_null_undefine_replace_empty({
          P_A_SheetId: rowData.A_SheetId,
          P_UserCd: vRdxuserInfo.UserID,
        })
      );

      if (response?.status === 200) {
        fAlertToast("SUCCESS", "Transaction posted successfully");
        closeModal();

        loader.style.display = "none";
      }
    } catch (error) {
      console.error("Error fetching cycle count data:", error);

      let errorMessage =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "An unexpected error occurred.";

      fAlertToast("FAILED", `Error: ${errorMessage}`);
    } finally {
      loader.style.display = "none";
    }
  };

  const fPost = () => {
    // if (itemDetails?.barcode !== "") {
    //   fAlertToast("FAILED", "Save current line item");
    //   return;
    // }

    if (countingDetail?.length == 0) {
      fAlertToast("INFO", "Add atleast one line item");
      return;
    }
    confirmAlert({
      title: "Approve",
      message: "Are you want to Approve?",
      buttons: [
        {
          className: "alertBtn",
          label: "Yes",
          onClick: () => {
            postApi();
          },
        },
        {
          className: "alertBtn",
          label: "No",
          onClick: () => "",
        },
      ],
    });
  };

  const headData = {
    // "Doc Type Code": palletHead?.VocTyp || "",
    "Trans ID": rowData?.A_SheetId || "",
    "Trans Date": moment(rowData?.A_Date).format("DD/MM/YYYY") || "",
    Location: (rowData?.A_Loc || "") + " - " + (rowData?.Loc_Name || ""),
  };

  return (
    <>
      <Box className="stock-detail">
        <Grid container spacing={1} pt={1} pb={vMediaQuery ? 0 : 1}>
          <Grid item xs={12} sm={5.5} md={5.5} lg={4} border={'1px soild red'}>
            {Object.entries(headData).map(([label, value], index) => (
              <Grid container spacing={0} key={index}>
                <Grid item xs={3} sm={3} md={3} >
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bolder !important" }} // Label with bold font weight
                  >
                    {label}
                  </Typography>
                </Grid>
                <Grid item xs={0.3} sm={0.3} md={0.5} >
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: "bolder !important" }} // Label with bold font weight
                  >
                    :
                  </Typography>
                </Grid>
                <Grid item xs={8.7} sm={7.5} md={8.5} >
                  <Typography
                    variant="body1"
                    // sx={{ fontWeight: 400}} // Label with bold font weight
                  >
                    {value}
                  </Typography>
                </Grid>
              </Grid>
            ))}
          </Grid>
          <Grid item xs={6} md={4}  lg={3.5} mt={1}>
            <TextField
              sx={{
                "& .MuiOutlinedInput-input": {
                  padding: "5.5px 10px !important",
                },
              }}
              label="Barcode"
              value={detailObj.Barcode}
              onChange={(event) =>
                setDetailObj((prev) => ({
                  ...prev,
                  Barcode: event.target.value,
                }))
              }
              name={"Barcode"}
              type="number"
              fullWidth
              // error={errors?.Barcode === "" ? false : true}
              // helperText={errors?.Barcode}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e._reactName === "onClick") {
                  getRowApi(detailObj.Barcode, detailObj.pending);
                }
              }}
              autoComplete="off"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => {
                        setDetailObj((prev) => ({
                          ...prev,
                          Barcode: "",
                        }));
                        setTimeout(() => {
                          document.getElementsByName("Barcode")[0]?.focus();
                        }, 100);
                      }}
                    >
                      <CloseIcon
                        onClick={(e) => {
                          if (e.key === "Enter" || e._reactName === "onClick") {
                            getRowApi(detailObj.Barcode, detailObj.pending);
                          }
                        }}
                      />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={3} md={1.5} lg={2.3}>
            <div
              style={{
                display: "flex",
                justifyContent: vMediaQuery ? "right" : "flex-end",
                textAlign: "left",
                alignItems: "flex-end",
                marginTop: 6,
              }}
            >
              {" "}
              <CmpCheckboxFieldIndeterminate
                xNameField={"Pending"}
                xChecked={detailObj.pending === true}
                xOnChange={(e) => {
                  const newValue = e.target.checked;
                  setDetailObj((prev) => ({
                    ...prev,
                    pending: newValue,
                  }));
                  getRowApi(detailObj.Barcode, newValue);
                }}
                xDisabled={false}
                xName={"pending"}
                xError={false}
                xErrorMessage={""}
              />
            </div>
          </Grid>
          <Grid item xs={2} sm={1} lg={2} textAlign={vMediaQuery ? "right" : "center"}>
            <Button
              variant="contained"
              color="primary"
              sx={{
                height: "30px",
                mt: vMediaQuery ? 0.5 : 1,
                textTransform: "capitalize",
              }}
              disabled={
                rowData?.A_CountStatus !== "ENTER"
                // ||
                // countingDetail.every((item) => item.Data.length === 0)
              }
              onClick={fPost}
            >
              Post
            </Button>
          </Grid>
        </Grid>

        <DetailComponent
          countingDetail={countingDetail}
          setCountingDetail={setCountingDetail}
          vMediaQuery={vMediaQuery}
          fKeyTabInput={fKeyTabInput}
          rowData={rowData}
          barcodeDetail={detailObj.Barcode}
        />
      </Box>
    </>
  );
};

export default CycleCountCountingDetailModal;
